/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';
import StatisticsSummaryGemData from './StatisticsSummaryGemData';
import StatisticsSummaryItemData from './StatisticsSummaryItemData';
import StatisticsSummaryMarketData from './StatisticsSummaryMarketData';
import StatisticsSummaryNftData from './StatisticsSummaryNftData';
import StatisticsSummaryTokenData from './StatisticsSummaryTokenData';
import StatisticsSummaryUserData from './StatisticsSummaryUserData';
import StatisticsSummaryWalletData from './StatisticsSummaryWalletData';
import StatisticsTokenGraphData from './StatisticsTokenGraphData';

/**
 * The PerplayStatisticsControllerDtoSummaryResponse model module.
 * @module model/PerplayStatisticsControllerDtoSummaryResponse
 * @version 1.0
 */
class PerplayStatisticsControllerDtoSummaryResponse {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoSummaryResponse</code>.
     * @alias module:model/PerplayStatisticsControllerDtoSummaryResponse
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoSummaryResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoSummaryResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoSummaryResponse} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoSummaryResponse} The populated <code>PerplayStatisticsControllerDtoSummaryResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoSummaryResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('userData')) {
                obj['userData'] = StatisticsSummaryUserData.constructFromObject(data['userData']);
            }
            if (data.hasOwnProperty('marketData')) {
                obj['marketData'] = StatisticsSummaryMarketData.constructFromObject(data['marketData']);
            }
            if (data.hasOwnProperty('tokenData')) {
                obj['tokenData'] = StatisticsSummaryTokenData.constructFromObject(data['tokenData']);
            }
            if (data.hasOwnProperty('nftData')) {
                obj['nftData'] = ApiClient.convertToType(data['nftData'], [StatisticsSummaryNftData]);
            }
            if (data.hasOwnProperty('itemData')) {
                obj['itemData'] = ApiClient.convertToType(data['itemData'], [StatisticsSummaryItemData]);
            }
            if (data.hasOwnProperty('gemData')) {
                obj['gemData'] = ApiClient.convertToType(data['gemData'], [StatisticsSummaryGemData]);
            }
            if (data.hasOwnProperty('walletData')) {
                obj['walletData'] = StatisticsSummaryWalletData.constructFromObject(data['walletData']);
            }
            if (data.hasOwnProperty('tokenGraph')) {
                obj['tokenGraph'] = ApiClient.convertToType(data['tokenGraph'], [StatisticsTokenGraphData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoSummaryResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoSummaryResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // validate the optional field `userData`
        if (data['userData']) { // data not null
          StatisticsSummaryUserData.validateJSON(data['userData']);
        }
        // validate the optional field `marketData`
        if (data['marketData']) { // data not null
          StatisticsSummaryMarketData.validateJSON(data['marketData']);
        }
        // validate the optional field `tokenData`
        if (data['tokenData']) { // data not null
          StatisticsSummaryTokenData.validateJSON(data['tokenData']);
        }
        if (data['nftData']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['nftData'])) {
                throw new Error("Expected the field `nftData` to be an array in the JSON data but got " + data['nftData']);
            }
            // validate the optional field `nftData` (array)
            for (const item of data['nftData']) {
                StatisticsSummaryNftData.validateJSON(item);
            };
        }
        if (data['itemData']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['itemData'])) {
                throw new Error("Expected the field `itemData` to be an array in the JSON data but got " + data['itemData']);
            }
            // validate the optional field `itemData` (array)
            for (const item of data['itemData']) {
                StatisticsSummaryItemData.validateJSON(item);
            };
        }
        if (data['gemData']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['gemData'])) {
                throw new Error("Expected the field `gemData` to be an array in the JSON data but got " + data['gemData']);
            }
            // validate the optional field `gemData` (array)
            for (const item of data['gemData']) {
                StatisticsSummaryGemData.validateJSON(item);
            };
        }
        // validate the optional field `walletData`
        if (data['walletData']) { // data not null
          StatisticsSummaryWalletData.validateJSON(data['walletData']);
        }
        if (data['tokenGraph']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['tokenGraph'])) {
                throw new Error("Expected the field `tokenGraph` to be an array in the JSON data but got " + data['tokenGraph']);
            }
            // validate the optional field `tokenGraph` (array)
            for (const item of data['tokenGraph']) {
                StatisticsTokenGraphData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['contentsReward'] = undefined;

/**
 * @member {module:model/StatisticsSummaryUserData} userData
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['userData'] = undefined;

/**
 * @member {module:model/StatisticsSummaryMarketData} marketData
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['marketData'] = undefined;

/**
 * @member {module:model/StatisticsSummaryTokenData} tokenData
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['tokenData'] = undefined;

/**
 * @member {Array.<module:model/StatisticsSummaryNftData>} nftData
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['nftData'] = undefined;

/**
 * @member {Array.<module:model/StatisticsSummaryItemData>} itemData
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['itemData'] = undefined;

/**
 * @member {Array.<module:model/StatisticsSummaryGemData>} gemData
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['gemData'] = undefined;

/**
 * @member {module:model/StatisticsSummaryWalletData} walletData
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['walletData'] = undefined;

/**
 * @member {Array.<module:model/StatisticsTokenGraphData>} tokenGraph
 */
PerplayStatisticsControllerDtoSummaryResponse.prototype['tokenGraph'] = undefined;






export default PerplayStatisticsControllerDtoSummaryResponse;

